import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

import { Fields } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import Chip from 'components/common/Chip';
import IconNote from 'components/icons/IconNote';
import IconClipRotated from 'components/icons/IconClipRotated';
import NarrativeViewDialog from 'components/workflow/NarrativeViewDialog';

import { fetchConnectedOrders } from 'redux/modules/connectedOrders';

import formatPrice from 'utils/formatPrice';
import documents from 'config/documents';

import ProductClaimViewItemSelection from './ProductClaimViewItemSelection';
import ProductClaimViewItemStatusFields from './ProductClaimViewItemStatusFields';
import ProductClaimViewItemAssigned from './ProductClaimViewItemAssigned';
import ProductClaimViewItemDriver from './ProductClaimViewItemDriver';
import ProductClaimViewItemRefill from './ProductClaimViewItemRefill';

const styles = theme => ({
  root: {
    marginTop: 15,
  },
  grid: {
    marginBottom: 10,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 4,
    },
  },
  gridShrink: {
    flexShrink: 1,
  },
  selection: {
    marginRight: -14,
  },
  header: {
    padding: '5px 24px',
    borderBottom: `1px solid ${theme.palette.primary.A100}`,
  },
  body: {
    padding: 24,
  },
  footer: {
    overflow: 'hidden',
  },
  gridHeader: {
    minHeight: 45,
  },
  chip: {
    marginLeft: 15,
    verticalAlign: 'top',
    height: 34,
    textTransform: 'uppercase',
    textDecoration: 'underline',
  },
  iconClipRotated: {
    width: 17,
    height: 18,
    marginRight: 10,
    color: theme.palette.grey[300],
  },
  iconNote: {
    width: 23,
    height: 23,
    marginRight: 10,
    verticalAlign: 'middle',
    color: theme.palette.grey[300],
  },
  driver: {
    marginTop: 8,
  },
  typographyLabel: {
    paddingTop: 8,
    paddingBottom: 8,
  },
});
class ProductClaimViewItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      narrativeViewDialogOpen: false,
    };

    this.onNarrativeChipClick = this.onNarrativeChipClick.bind(this);
    this.onNarrativeViewDialogClose = this.onNarrativeViewDialogClose.bind(this);
    this.onUpdateSuccess = this.onUpdateSuccess.bind(this);
  }

  onNarrativeChipClick() {
    this.setState({ narrativeViewDialogOpen: true });
  }

  onNarrativeViewDialogClose() {
    this.setState({ narrativeViewDialogOpen: false });
  }

  onUpdateSuccess() {
    const { ID, Type, actions, ...otherProps } = this.props;
    if (Type === 'Recurring' || Type === 'Rental') {
      actions.fetchConnectedOrders({
        triggerLoading: false,
        orderLineID: [ID],
        orderID: otherProps['Order ID'],
      });
    }
  }

  render() {
    const {
      ID,
      Narrative,
      Status,
      Type,
      Units,
      Charge,
      Modifiers,
      Refill,
      Cost,
      Description,
      Authorization,
      Driver,
      classes,
      submitting,
      change,
      history,
      disabled,
      ...otherProps
    } = this.props;
    const { narrativeViewDialogOpen } = this.state;
    return (
      <Paper
        className={classes.root}
        component="article"
      >
        <header className={classes.header}>
          <Grid
            className={classes.gridHeader}
            container
            justify="space-between"
            alignItems="center"
            wrap="nowrap"
            spacing={0}
          >
            <Grid
              className={classes.gridShrink}
              item
            >
              <Grid
                container
                justify="space-between"
                alignItems="center"
                wrap="nowrap"
                spacing={8}
              >
                <Grid item>
                  <ProductClaimViewItemSelection
                    className={classes.selection}
                    ID={ID}
                  />
                </Grid>
                <Grid item>
                  <Typography
                    component="span"
                  >
                    {otherProps['HCPC S Code']['HCPC S Code']}
                  </Typography>
                </Grid>
                <Grid
                  className={classes.gridShrink}
                  item
                >
                  <Typography
                    component="span"
                    color="secondary"
                  >
                    {otherProps.Product['Product Name']}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <Grid
                container
                justify="space-between"
                alignItems="center"
                wrap="nowrap"
                spacing={8}
              >
                <Grid item>
                  {otherProps['CMN/AMB'] &&
                    <Chip
                      className={classes.chip}
                      size="md"
                      onClick={() => {
                        const CMNDocument = documents.find(item => item.Name === otherProps['CMN/AMB']);
                        history.push(`/workflow/order/print/${otherProps['Order ID']}/document/${CMNDocument.ID}/${ID}`);
                      }}
                      label={(
                        <Fragment>
                          <IconClipRotated className={classes.iconClipRotated} />
                          CMN/AMB
                        </Fragment>
                      )}
                    />
                  }
                  {Narrative &&
                    <Fragment>
                      <Chip
                        className={classes.chip}
                        size="md"
                        label={(
                          <Fragment>
                            <IconNote className={classes.iconNote} />
                            Narrative
                          </Fragment>
                        )}
                        onClick={this.onNarrativeChipClick}
                      />
                      <NarrativeViewDialog
                        open={narrativeViewDialogOpen}
                        onClose={this.onNarrativeViewDialogClose}
                        Narrative={Narrative}
                      />
                    </Fragment>
                  }
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </header>
        <div className={classes.body}>
          <Grid
            container
            wrap="nowrap"
            alignItems="flex-start"
            spacing={16}
          >
            <Grid item xs={2}>
              <Typography className={classes.typographyLabel} color="secondary">
                Assigned to
              </Typography>
              <Typography className={classes.typographyLabel} color="secondary">
                Driver
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <ProductClaimViewItemAssigned
                ID={ID}
                disabled={submitting || disabled}
                change={change}
              />
              <ProductClaimViewItemDriver
                className={classes.driver}
                ID={ID}
                disabled={submitting || disabled}
                change={change}
              />
            </Grid>
            <Grid item xs={2}>
              <Typography className={classes.typographyLabel} color="secondary">
                Status
              </Typography>
            </Grid>
            <Grid item xs={5}>
              
              <Fields
                names={[
                  `${ID}-orderLine.Status Name`,
                  `${ID}-orderLine.Status`,
                ]}
                name={`${ID}-orderLine`}
                component={ProductClaimViewItemStatusFields}
                disabled={submitting || disabled}
              />
            </Grid>
          </Grid>
          <Grid
            container
            wrap="nowrap"
            alignItems="center"
            spacing={16}
          >
            <Grid item xs={2}>
              <Typography color="secondary">
                Date of Service
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography>
                {otherProps['Date of Service From']}
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography color="secondary">
                Type
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography>
                {Type}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography color="secondary">
                Units
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography>
                {Units}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            wrap="nowrap"
            alignItems="center"
            spacing={16}
          >
            <Grid item xs={2}>
              <Typography color="secondary">
                Modifiers
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography>
                {Modifiers}
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography color="secondary">
                Cost
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography>
                {formatPrice(Cost)}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography color="secondary">
                Place of SRV
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography>
                {otherProps['Place of SRV']}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            wrap="nowrap"
            alignItems="flex-start"
            spacing={16}
          >
            <Grid item xs={2}>
              <Typography color="secondary">
                Authorization
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography>
                {Authorization}
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography color="secondary">
                Charge
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography>
                {formatPrice(Charge)}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography color="secondary">
                Description
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography>
                {Description}
              </Typography>
            </Grid>
          </Grid>
        </div>
        {Boolean(Refill && Refill > 0) &&
          <div className={classes.footer}>
            <ProductClaimViewItemRefill
              Refill={Refill}
              Type={Type}
              {...{ 'Date of Service From': otherProps['Date of Service From'] }}
            />
          </div>
        }
      </Paper>
    );
  }
}

ProductClaimViewItem.propTypes = {
  ID: PropTypes.number.isRequired,
  'CMN/AMB': PropTypes.string,
  Narrative: PropTypes.string,
  'Assigned User': PropTypes.shape({
    ID: PropTypes.number.isRequired,
    'First Name': PropTypes.string.isRequired,
    'Last Name': PropTypes.string.isRequired,
  }).isRequired,
  Driver: PropTypes.shape({
    ID: PropTypes.number,
    'First Name': PropTypes.string,
    'Last Name': PropTypes.string,
  }).isRequired,
  Type: PropTypes.string.isRequired,
  Units: PropTypes.number.isRequired,
  Charge: PropTypes.string.isRequired,
  Modifiers: PropTypes.string,
  Cost: PropTypes.string,
  Refill: PropTypes.number,
  'Date of Service From': PropTypes.string.isRequired,
  'Workflow Status': PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })).isRequired,
  'Place of SRV': PropTypes.number.isRequired,
  Description: PropTypes.string.isRequired,
  Authorization: PropTypes.string,
  actions: PropTypes.shape({
    fetchConnectedOrders: PropTypes.func.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  submitting: PropTypes.bool.isRequired,
  change: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    header: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
    footer: PropTypes.string.isRequired,
    selection: PropTypes.string.isRequired,
    grid: PropTypes.string.isRequired,
    gridShrink: PropTypes.string.isRequired,
    gridHeader: PropTypes.string.isRequired,
    iconClipRotated: PropTypes.string.isRequired,
    iconNote: PropTypes.string.isRequired,
  }).isRequired,
};

ProductClaimViewItem.defaultProps = {
  'CMN/AMB': null,
  Narrative: null,
  Refill: null,
  Modifiers: null,
  Cost: null,
  Authorization: null,
  disabled: false,
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ fetchConnectedOrders }, dispatch),
});

export default connect(null, mapDispatchToProps)(
  withRouter(withStyles(styles)(ProductClaimViewItem)),
);



// WEBPACK FOOTER //
// ./src/components/workflow/ProductClaimView/ProductClaimViewItem.js